
 
export const FETCH_ORGANIZATIONS_REQUEST = 'organizations/FETCH_ORGANIZATIONS_REQUEST';
export const FETCH_ORGANIZATIONS_SUCCESS = 'organizations/FETCH_ORGANIZATIONS_SUCCESS';
export const FETCH_ORGANIZATIONS_FAILURE = 'organizations/FETCH_ORGANIZATIONS_FAILURE';

 
export const FETCH_ORGANIZATION_REQUEST = 'organizations/FETCH_ORGANIZATION_REQUEST';
export const FETCH_ORGANIZATION_SUCCESS = 'organizations/FETCH_ORGANIZATION_SUCCESS';
export const FETCH_ORGANIZATION_FAILURE = 'organizations/FETCH_ORGANIZATION_FAILURE';

 
export const DELETE_ORGANIZATION_REQUEST = 'organizations/DELETE_ORGANIZATION_REQUEST';
export const DELETE_ORGANIZATION_SUCCESS = 'organizations/DELETE_ORGANIZATION_SUCCESS';
export const DELETE_ORGANIZATION_FAILURE = 'organizations/DELETE_ORGANIZATION_FAILURE';

 
export const CREATE_ORGANIZATION_REQUEST = 'organizations/CREATE_ORGANIZATION_REQUEST';
export const CREATE_ORGANIZATION_SUCCESS = 'organizations/CREATE_ORGANIZATION_SUCCESS';
export const CREATE_ORGANIZATION_FAILURE = 'organizations/CREATE_ORGANIZATION_FAILURE';

 
export const UPDATE_ORGANIZATION_REQUEST = 'organizations/UPDATE_ORGANIZATION_REQUEST';
export const UPDATE_ORGANIZATION_SUCCESS = 'organizations/UPDATE_ORGANIZATION_SUCCESS';
export const UPDATE_ORGANIZATION_FAILURE = 'organizations/UPDATE_ORGANIZATION_FAILURE';


export const UPDATE_FIELD = 'organizations/UPDATE_FIELD';
export const SET_DEFAULT_DATA = 'organizations/SET_DEFAULT_DATA';
